import React, { useState, useEffect } from 'react';
import axios from '../../api/axios';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [countdown, setCountdown] = useState(0);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  // ⏳ Countdown timer
  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setTimeout(() => setCountdown(prev => prev - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [countdown]);

  // 🔁 Auto-clear error after 10 seconds
  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => setError(''), 5000);
      return () => clearTimeout(timer);
    }
  }, [error]);

  const sendOtp = async () => {
    setError('');
    setMessage('');
    try {
      await axios.post('/api/verify/forgot-password-otp', { email });
      setMessage('OTP sent to your email.');
      setCountdown(120);
      setStep(2);
    } catch (err) {
      setError(err?.response?.data?.message || 'Failed to send OTP');
    }
  };

  const verifyOtp = async () => {
    try {
      const res = await axios.post('/api/verify/check-otp', { email, otp });
      if (res.data.verified) {
        setStep(3);
        setMessage('');
        setError('');
      }
    } catch (err) {
      setError(err?.response?.data?.message || 'Invalid OTP');
    }
  };

  const resetPassword = async () => {
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      await axios.post('/api/auth/reset-password', {
        email,
        newPassword,
      });
      setMessage('Password reset successful. You can now log in.');
      setStep(4);
    } catch (err) {
      setError(err?.response?.data?.message || 'Reset failed');
    }
  };

  return (
    <div className="forgot-password-wrapper">
      <div className="forgot-password-page">
        <div className="logo-container">
          <img src="/smulogo.png" alt="SMU Logo" className="logo" />
        </div>

        <h2>Forgot Password</h2>

        {step === 1 && (
          <>
            <p>Enter your email to receive an OTP.</p>
            <input
              type="email"
              placeholder="Your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button onClick={sendOtp} disabled={countdown > 0}>
              {countdown > 0 ? `Wait ${countdown}s` : 'Send OTP'}
            </button>
          </>
        )}

        {step === 2 && (
          <>
            <p>Check your email and enter the OTP below.</p>
            <input
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              required
            />
            <button onClick={verifyOtp}>Verify OTP</button>
            {countdown > 0 && (
              <p style={{ marginTop: '10px', fontSize: '14px', color: '#003366' }}>
                OTP valid for: <strong>{countdown}s</strong>
              </p>
            )}
          </>
        )}

        {step === 3 && (
          <>
            <p>Enter a new password.</p>
            <input
              type="password"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
            <input
              type="password"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            <button onClick={resetPassword}>Reset Password</button>
          </>
        )}

        {step === 4 && (
          <p className="success">
            Password successfully reset. <a href="/login">Go to Login</a>
          </p>
        )}

        {message && <p className="info">{message}</p>}
        {error && <p className="error">{error}</p>}
      </div>
    </div>
  );
};

export default ForgotPassword;
